import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

// Area codes (geohash) — the same ones the server and the app use.
const B32 = "0123456789bcdefghjkmnpqrstuvwxyz";
export function geohash(lat, lng, precision = 5) {
  let latLo = -90, latHi = 90, lngLo = -180, lngHi = 180;
  let out = "", bits = 0, ch = 0, even = true;
  while (out.length < precision) {
    if (even) {
      const mid = (lngLo + lngHi) / 2;
      if (lng >= mid) { ch = (ch << 1) | 1; lngLo = mid; } else { ch = ch << 1; lngHi = mid; }
    } else {
      const mid = (latLo + latHi) / 2;
      if (lat >= mid) { ch = (ch << 1) | 1; latLo = mid; } else { ch = ch << 1; latHi = mid; }
    }
    even = !even;
    if (++bits === 5) { out += B32[ch]; bits = 0; ch = 0; }
  }
  return out;
}

function miles(aLat, aLng, bLat, bLng) {
  const R = 3958.8, r = Math.PI / 180;
  const dLat = (bLat - aLat) * r, dLng = (bLng - aLng) * r;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(aLat * r) * Math.cos(bLat * r) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

const FILLER = new Set([
  "the", "bar", "and", "grill", "pub", "saloon", "tavern", "lounge", "restaurant", "sports", "inc", "llc",
  "co", "company", "of", "at", "on", "n", "a", "s", "taproom", "brewing", "brewery", "club",
]);
const words = (name) =>
  String(name || "").toLowerCase().replace(/[’']/g, "").replace(/[^a-z0-9]+/g, " ").split(" ")
    .filter((w) => w.length > 1 && !FILLER.has(w));
function sameName(a, b) {
  const wa = words(a), wb = new Set(words(b));
  if (!wa.length || !wb.size) {
    const pa = String(a).toLowerCase().replace(/[^a-z0-9]/g, "");
    const pb = String(b).toLowerCase().replace(/[^a-z0-9]/g, "");
    return !!pa && !!pb && (pa.includes(pb) || pb.includes(pa));
  }
  return wa.some((w) => wb.has(w));
}

/**
 * Is one of OUR bars (any source) at this spot with a similar name?
 * Returns { id, data } or null. Used so claiming a Google result picks up
 * the bar that's already in the app instead of making a duplicate.
 */
export async function findOurBarNear(name, lat, lng) {
  if (lat == null || lng == null) return null;
  const cells = new Set();
  for (const dLat of [-0.0015, 0, 0.0015]) {
    for (const dLng of [-0.002, 0, 0.002]) cells.add(geohash(lat + dLat, lng + dLng, 5));
  }
  const snap = await getDocs(query(collection(db, "bars"), where("gh5", "in", [...cells])));
  let best = null;
  let bestDist = Infinity;
  snap.docs.forEach((d) => {
    const x = d.data();
    if (x.lat == null || x.lng == null) return;
    const dist = miles(lat, lng, Number(x.lat), Number(x.lng));
    const ok = dist < 0.02 || (dist < 0.075 && sameName(name, x.name));
    if (ok && dist < bestDist) {
      best = { id: d.id, data: x };
      bestDist = dist;
    }
  });
  return best;
}
